<template>
  <Dialog
    v-model="dialogVisible"
    title="Choose Provider"
    dialog-type="primary"
    dialog-size="small"
    :close-on-overlay="false"
    @close="$emit('close')"
  >
    <template #header-icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
        <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
        <line x1="12" y1="22.08" x2="12" y2="12"></line>
      </svg>
    </template>

    <div class="choose-provider-body">
      <div v-if="loading" class="loading-wrapper">
        <Loading :loading="loading" loadingText="Loading..." />
      </div>
      <template v-else>
        <div class="prompt-text">Please select Client ID before placing order</div>
        <SingleSelector
          class="provider-select"
          size="medium"
          :options="providerOptions"
          :modelValue="localProviderId"
          placeholder="Choose Provider"
          @update:modelValue="localProviderId = $event"
        />
      </template>
    </div>

    <template #footer>
      <ResponsiveButton
        button_type="outlined"
        built_in_theme="error"
        size="medium"
        display_name="Cancel"
        @click-button="$emit('close')"
      />
      <ResponsiveButton
        button_type="filled"
        built_in_theme="dark"
        size="medium"
        display_name="Continue"
        :disabled="!localProviderId || loading"
        @click-button="handleConfirm"
      />
    </template>
  </Dialog>
</template>

<script>
import Loading from '@/NewLibrary/Loading/Loading.vue';

export default {
  name: 'ChooseProviderDialog',
  components: {
    Loading,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    providers: {
      type: Array,
      default: () => [],
    },
    selectedProviderId: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'confirm'],
  data() {
    return {
      localProviderId: '',
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        if (!val) this.$emit('close');
      },
    },
    providerOptions() {
      return (this.providers || []).map((provider) => ({
        label: `${provider.name} (${provider.id})`,
        value: String(provider.id),
      }));
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          return;
        }
        const selectedId = this.selectedProviderId ? String(this.selectedProviderId) : '';
        const matched = this.providerOptions.some((item) => item.value === selectedId);
        if (matched) {
          this.localProviderId = selectedId;
          return;
        }
        this.localProviderId = '';
      },
    },
  },
  methods: {
    handleConfirm() {
      if (!this.localProviderId) {
        return;
      }
      this.$emit('confirm', this.localProviderId);
    },
  },
};
</script>

<style scoped>
.choose-provider-body {
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  gap: 12px;
}

.prompt-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #1f1f1f;
}

.provider-select {
  width: 100%;
}

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.choose-provider-body :deep(.single-selector-unit-wrapper) {
  width: 100%;
}
</style>

